import { useEffect } from 'react';
import EVENTS from '@/utils/Constants/Events';

// Context
import { useCompareContext } from '@/context/compare';

export default () => {
  const [, { pushProductCompare }] = useCompareContext();

  useEffect(() => {
    DLG.EVE.on(EVENTS.LISTING.COMPARE.PUSH, data => pushProductCompare(data));
  }, []);
};
